$(document).ready(function () {
  const addToCartElement = document.querySelector('#AddToCart');
  const isElementInViewport = (el) => {
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    /* a hidden element (e.g. Intelligems B test) reports an all-zero rect, which would
       otherwise read as "at the top-left of the screen" and force the sticky bar hidden
       forever. Treat a zero-size rect as not in the viewport. */
    if (rect.width === 0 && rect.height === 0) return false;
    return (rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth));
  };
  const handleVisibilityChange = () => {
    if (isElementInViewport(addToCartElement)) { $("#StickyAddToCart").hide() } else { $("#StickyAddToCart").show() }
  };
  window.addEventListener('scroll', handleVisibilityChange);
  handleVisibilityChange();
});